export default __webpack_public_path__ + "static/media/google_play_es.4c58a35a.png";